const TRAILING_SHORT_CODE = /\s*\([^()]*\)\s*$/;

const stripCompanyShortCode = (name?: null | string): string => {
	if (!name) return "";
	return name.replace(TRAILING_SHORT_CODE, "").trim();
};

export default stripCompanyShortCode;
